function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8 16.0039C12.4183 16.0039 16 12.4222 16 8.00391C16 3.58563 12.4183 0.00390625 8 0.00390625C3.58172 0.00390625 0 3.58563 0 8.00391C0 12.4222 3.58172 16.0039 8 16.0039Z",
  fill: "#60A5F9"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.62069 7.91987C5.95285 6.90378 7.508 6.23391 8.28611 5.91027C10.5078 4.98619 10.9694 4.82567 11.2703 4.82037C11.3365 4.8192 11.4845 4.8356 11.5803 4.91338C11.6613 4.97905 11.6835 5.06777 11.6942 5.13003C11.7049 5.19229 11.7181 5.33413 11.7076 5.44496C11.5872 6.70995 11.0662 9.77975 10.8012 11.1966C10.6891 11.7961 10.4683 11.9971 10.2545 12.0167C9.78991 12.0595 9.43714 11.7097 8.98717 11.4148C8.28307 10.9532 7.88529 10.6659 7.20184 10.2155C6.41199 9.69501 6.92402 9.40894 7.37415 8.94141C7.49195 8.81905 9.53888 6.95722 9.5785 6.78832C9.58345 6.76719 9.58805 6.68846 9.54127 6.64688C9.4945 6.6053 9.42546 6.61952 9.37564 6.63083C9.30502 6.64686 8.1802 7.39032 6.00119 8.86121C5.68192 9.08045 5.39273 9.18727 5.13362 9.18167C4.84798 9.1755 4.29852 9.02017 3.89006 8.88739C3.38905 8.72453 2.99087 8.63843 3.02554 8.36185C3.0436 8.21779 3.24199 8.07046 3.62069 7.91987Z",
  fill: "white"
});

function SvgTelegramIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramIcon);
export default __webpack_public_path__ + "static/media/Telegram-icon.fb6e6c9c.svg";
export { ForwardRef as ReactComponent };